###
Inject global services and helpers into Nuxt
###
import * as storefront from 'library/services/shopify/storefront'
import * as helpers from 'library/services/helpers'
import ShopifyGtmInstrumentor from 'shopify-gtm-instrumentor'
import NonShopifyGtmInstrumentor from '~/services/non-shopify-gtm-instrumentor'
export default ({ app, error }, inject) ->

	# API Adapters
	inject 'storefront', storefront

	# Shopify GTM Instrumentor
	inject 'gtmEcomm', gtmEcomm = new ShopifyGtmInstrumentor
		debug: process.env.APP_ENV == 'dev'

	# Make a helper for non-Shopify products for populating most of the same
	# dataLayer variables
	inject 'gtmNonEcomm', new NonShopifyGtmInstrumentor
		debug: process.env.APP_ENV == 'dev'

	# Global helpers
	inject name, func for name, func of helpers

	# Inject global var that can be used to conditionally enable cart UI. This
	# isn't stored in the cart plugin because that plugin is client only.
	inject 'shopifyCartEnabled', process.env.SHOPIFY_CART_ENABLED
	inject 'grassdoorCartEnabled', process.env.GRASSDOOR_CART_ENABLED
